import ApiClient from 'apis/ApiClient'
const apiClient = new ApiClient()

export function getServerTime() {
  return apiClient.get('/timestamp')
}

export const getLanguageSuffixPromise = () => {
  return apiClient
    .get('/util/language-suffix')
    .then((resp) => Promise.resolve(resp))
}

export const getUtilConfigsPromise = (nameList) => {
  return apiClient
    .post('/util/configs', { body: { name: nameList } })
    .then((resp) => Promise.resolve(resp))
}
